import { ArrowUpRight, Mail, MapPin, Navigation, Phone, ShieldCheck } from "lucide-react";
import { COMPANY, DIRECTIONS_URL, MAP_EMBED_URL, MAP_LINK_URL } from "@/data/company";

const CHANNELS = [
  { id: "phone", icon: Phone, label: "Telefono", value: COMPANY.phone, href: COMPANY.phoneHref, note: "Chiamaci per informazioni su prodotti e ordini" },
  { id: "email", icon: Mail, label: "Email", value: COMPANY.email, href: `mailto:${COMPANY.email}`, note: "Ti rispondiamo il prima possibile" },
  { id: "pec", icon: ShieldCheck, label: "PEC", value: COMPANY.pec, href: `mailto:${COMPANY.pec}`, note: "Per comunicazioni formali, recesso e reclami" },
];

export const ContactChannels = () => (
  <ul className="grid gap-4">
    {CHANNELS.map(({ id, icon: Icon, label, value, href, note }) => (
      <li key={id}>
        <a href={href} data-testid={`contact-${id}-link`} className="group flex items-center gap-5 rounded-3xl border border-copper/20 bg-cream p-6 transition-[border-color,background-color] duration-300 hover:border-copper hover:bg-parchment">
          <span className="grid h-14 w-14 shrink-0 place-items-center rounded-full bg-navy text-ivory transition-transform duration-300 group-hover:-rotate-6">
            <Icon className="h-6 w-6" strokeWidth={1.5} />
          </span>
          <span className="min-w-0 flex-1">
            <span className="block text-[13px] uppercase tracking-[0.2em] text-copper-deep">{label}</span>
            <span className="mt-1 block break-all font-display text-2xl text-navy sm:text-3xl">{value}</span>
            <span className="mt-1 block text-[15px] text-slate2">{note}</span>
          </span>
          <ArrowUpRight className="hidden h-5 w-5 shrink-0 text-copper transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 sm:block" />
        </a>
      </li>
    ))}
  </ul>
);

const mapBtn = "inline-flex h-12 items-center gap-2 rounded-full px-5 text-[15px] font-medium transition-colors";

export const CompanyMap = () => (
  <figure className="overflow-hidden rounded-[2rem] border border-copper/20 bg-cream" data-testid="contact-map">
    <iframe title={`Mappa: ${COMPANY.address}`} src={MAP_EMBED_URL} loading="lazy" className="block aspect-[4/3] w-full border-0 lg:aspect-[5/4]" data-testid="contact-map-iframe" />
    <figcaption className="flex flex-col gap-5 p-6 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        <MapPin className="mt-1 h-5 w-5 shrink-0 text-copper" strokeWidth={1.5} />
        <div>
          <p className="text-[13px] uppercase tracking-[0.2em] text-copper-deep">Sede legale</p>
          <p className="mt-1 text-[17px] text-navy" data-testid="contact-address">{COMPANY.street}<br />{COMPANY.cityLine}</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        <a href={MAP_LINK_URL} target="_blank" rel="noopener noreferrer" data-testid="contact-map-open" className={`${mapBtn} border border-navy/20 text-navy hover:bg-sand`}>
          Apri la mappa <ArrowUpRight className="h-4 w-4" />
        </a>
        <a href={DIRECTIONS_URL} target="_blank" rel="noopener noreferrer" data-testid="contact-map-directions" className={`${mapBtn} bg-navy text-ivory hover:bg-navy-700`}>
          <Navigation className="h-4 w-4" /> Indicazioni
        </a>
      </div>
    </figcaption>
  </figure>
);
